var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"status-point",class:'bg-' + _vm.type}),_c('span',{class:'text-' + _vm.type},[_vm._v(" "+_vm._s(_vm.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }